import React from 'react'

const EditPartyTemplateContext = React.createContext();

export default EditPartyTemplateContext
